import type { PurchasableNft } from "@/app/nft/buy/nfts-to-buy/scope"
import type { PriceValue } from "@anaconda/core/price/types"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useCallback } from "react"
import { useSwitchEvmChain } from "../../use-switch-evm-chain"
import { BatchBuyTransactionMoleculeReatom } from "./evm-batch-buy-molecule.reatom"

export function useEvmBatchBuy(
  nfts: PurchasableNft[],
  price: PriceValue | undefined,
) {
  const { batchBuyAction } = useMolecule(BatchBuyTransactionMoleculeReatom)
  const isPending = batchBuyAction.pending() > 0

  const onSuccess = useCallback(() => {
    batchBuyAction({ nfts, price })
  }, [batchBuyAction, nfts, price])

  // Get blockchain from first NFT, all NFTs in batch should be on same chain
  const blockchain = nfts[0]?.collection.blockchain

  const { action, switchInProgress } = useSwitchEvmChain<void>(
    blockchain,
    onSuccess,
  )

  return { mutate: action, isPending: isPending || switchInProgress }
}
